import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { FormValues } from 'components/Dashboards/Reporting/ReportSettingsModal/ReportSettingsModal.types';

export const specificUsersOptionSelected = (
    getValues: UseFormGetValues<FormValues>,
    username: string | undefined,
    setValue: UseFormSetValue<FormValues>,
) => {
    // When moving to the users table the columns are being cut to 50%
    // THERE ARE SEVERAL OPTIONS TO DEAL WITH THIS
    // ( setTimeout in useEffect, use visibility hidden or setTimeout here in the function)
    setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
    }, 0);
    const usersAccessList = getValues('userAccessList') ?? [];
    const updatedUserAccessInfo = usersAccessList.map((user) => {
        if (user.userName === username) {
            return {
                ...user,
                hasAccess: true,
                notifyOnUpload: true,
            };
        } else {
            return user;
        }
    });
    setValue('allUsersAccess', false, { shouldDirty: true });
    setValue('notifyAllUsersOnUpload', false, { shouldDirty: true });
    setValue('userAccessList', updatedUserAccessInfo, { shouldDirty: true });
};

export const allUsersOptionSelected = (setValue: UseFormSetValue<FormValues>) => {
    setValue('allUsersAccess', true, { shouldDirty: true });
};
